import { formatDistanceToNow, format, differenceInDays } from 'date-fns';
import { nb } from 'date-fns/locale';

export default function formatRelativeDate(
    date: number | Date,
    newTodayText: boolean = false,
): string {
    const dayDifference = differenceInDays(new Date(), date);

    // if less than a day old
    if (newTodayText && dayDifference < 1) {
        return 'Ny i dag';
    } else if (dayDifference < 3) {
        let relativeText = formatDistanceToNow(date, {
            locale: nb,
            addSuffix: true,
        });

        // we don't want 'omtrent 16 timer siden', we want '16 timer siden'
        if (relativeText.startsWith('omtrent ')) {
            relativeText = relativeText.replace('omtrent ', '');
        }

        return relativeText;
    }

    return format(date, 'd. MMM yyyy', { locale: nb });
}
